import { render } from "./DonationList.vue?vue&type=template&id=52ab70e8"
import script from "./DonationList.vue?vue&type=script&lang=js"
export * from "./DonationList.vue?vue&type=script&lang=js"

import "./DonationList.vue?vue&type=style&index=0&id=52ab70e8&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__